import { connect } from "react-redux";

import api from "api";
import PasswordUpdate from "components/PasswordUpdate";
import { changeForm, setErrors, init } from "redux/modules/passwordUpdate";
import { openErrorDialog } from "redux/modules/errorDialog";
import history from "utils/history";
import { setFalseToIsTempPassword } from "redux/modules/header";
import { showSnackbar } from "redux/modules/snackbar";

const mapStateToProps = state => {
  return { ...state.passwordUpdate };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  changeForm: (key, value) => {
    dispatch(changeForm(key, value));
  },
  handleSubmit: (currentPassword, password, passwordConfirmation) => {
    const params = {
      currentPassword,
      password,
      passwordConfirmation
    };

    api
      .patch("password", params)
      .then(res => {
        if (res.errors) {
          dispatch(setErrors(res.errors));
        } else {
          dispatch(init());
          dispatch(setFalseToIsTempPassword());
          dispatch(showSnackbar("パスワードを更新しました。"));
        }
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  historyPush: path => history.push(path, ownProps),
  init: () => dispatch(init())
});

export default connect(mapStateToProps, mapDispatchToProps)(PasswordUpdate);



// WEBPACK FOOTER //
// ./src/containers/PasswordUpdateContainer.js